import {
    AppBar,
    Button,
    Dialog,
    DialogContent,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    Toolbar,
    useTheme
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@mui/styles';
import { LoadingButton } from '@mui/lab';
import NoDataAvailable from '../common/NoDataAvailable';
import request from '../../utils/request';
// import CancelAlert from './CancelAlert';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SnackbarAlert from '../common/SnackbarAlert';
import EndorsementPreview from './EndorsementPreview';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import EndorsementPolicyQCPreview from './EndorsementPolicyQCPreview';
import PolicyCompareDetailView from './PolicyCompareDetailView';
import EndorsementCloseRemark from './EndorsementCloseRemark';
const toolbarBtnSx = {
    marginTop: '15px',
    marginRight: '22px',
    maxHeight: '38px'

};


const useStyles = makeStyles(() => ({
    compareItemBox: {
        minHeight: '94.2vh',
        paddingLeft: 10,
        paddingTop: 5,
        border: '2px solid #ddd'
    },
    overFlow: {
        overflowY: 'auto',
        overflowx: 'auto'
    },
    actionBtn: {
        position: 'absolute',
        right: 10,
        top: 50
    }
}));

function PolicyDataCompare({ handleClose, PolicyCompare }) {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const classes = useStyles();
    const viewer = useRef(null);
    const [loader, setLoader] = useState<boolean>(false);
    const [draftLoader, setDraftLoader] = useState<boolean>(false);
    const [openActionDrawer, setOpenActionDrawer] = useState(false);
    const [qcRemarkOfEachSections, setQcRemarkOfEachSections] = useState(null);
    const [enableFinalApprove, setEnableFinalApprove] = useState(false);
    const [openEndorsementPreview, setOpenEndorsementPreview] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openCancelAlert, setOpenCancelAlert] = useState({
        status: false,
        type: null
    });
    const [showSnackBarAlert, setShowSnackBarAlert] = useState({
        status: false,
        type: 'success',
        message: null
    });

    const open = Boolean(anchorEl);

    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCancelPolicy = () => {
        setAnchorEl(null);
        openPolicyCancelPrompt('Cancelled');
    };

    const handleCancellationWithReissue = () => {
        setAnchorEl(null);
        openPolicyCancelPrompt('CancelledAndReissued');
    };

    const handleSnackbarClose = () => {
        setShowSnackBarAlert({ status: false, type: null, message: null });
    };

    const openEndorsementPreviewWindow = () => {

        setTimeout(() => {
            const hasEmptyRemarks = hasEmptyRemarksRecursive(qcRemarkOfEachSections);

            if (hasEmptyRemarks) {
                setShowSnackBarAlert({
                    status: true,
                    type: 'error',
                    message:
                        'Please add remarks for all modules requiring endorsement before submitting.'
                });
                return;
            }
            setOpenEndorsementPreview(true);
        }, 1000)

    }

    useEffect(() => {
        if (PolicyCompare) {
            if (PolicyCompare?.qcData?.insured_details) {
                setQcRemarkOfEachSections(PolicyCompare?.qcData);
            } else {
                setQcRemarkOfEachSections({
                    "insured_details": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },

                    "risk_description_details": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },
                    "policy_details": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false

                    },

                    "dynamic_form_detail": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },
                    "dynamic_form_2_detail": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },
                    "dynamic_form_3_detail": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },
                    "claim_details": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },
                    "sum_insured_sections": {},

                    "coverages_requested": {
                        "status": "endorsement_required",
                        "remarks": "Missing coverages",
                        "isActive": false,
                        "selected_coverage_list": [],
                        "unSelected_coverage_list": [],
                        "selected_coverages": [],
                        "unSelected_coverages": []
                    },

                    "clauses_requested": {
                        "status": "endorsement_required",
                        "remarks": "Missing clauses",
                        "isActive": false,
                        "selected_clauses_list": [],
                        "unSelected_clauses_list": [],
                        "selected_clauses": [],
                        "unSelected_clauses": []
                    },
                    "hypothecation_details": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },

                    "insurance_premium_details": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false

                    },

                    "placement_details": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false

                    },
                    "payment_details": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },

                    "installment_details": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },
                    "co_insurance_details": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },
                    "policy_seal_and_sign": {
                        "status": "endorsement_required",
                        "remarks": "Missing",
                        "isActive": false
                    },
                    "warranties_exclusions": {
                        "value": "",
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },
                    "suggestedDeductible": {
                        "status": "endorsement_required",
                        "remarks": "",
                        "isActive": false
                    },
                });
            }

            setDetailsView({
                status: true,
                data: { id: PolicyCompare?.insurancePolicy?.placementId, rfqId: PolicyCompare?.insurancePolicy?.rfqId },
                policyDetail: PolicyCompare
            });
        }
    }, [PolicyCompare]);



    const secondCheckTimerRef = useRef(null);

    useEffect(() => {
        if (!qcRemarkOfEachSections) return;
        checkAllModuleIsVerified();
        if (secondCheckTimerRef.current) {
            clearTimeout(secondCheckTimerRef.current);
        }

        secondCheckTimerRef.current = setTimeout(() => {
            checkAllModuleIsVerified();
        }, 2000);


        return () => {
            if (secondCheckTimerRef.current) {
                clearTimeout(secondCheckTimerRef.current);
            }
        };
    }, [qcRemarkOfEachSections]);

    const checkAllModuleIsVerified = () => {
        let numberOfModule = 0;
        let numberOfVerifiedModules = 0;

        const parentSections = [
            "insured_details",
            "risk_description_details",
            "policy_details",
            "dynamic_form_detail",
            "dynamic_form_2_detail",
            "dynamic_form_3_detail",
            "claim_details",
            "sum_insured_sections",
            "coverages_requested",
            "clauses_requested",
            "hypothecation_details",
            "insurance_premium_details",
            "placement_details",
            "payment_details",
            "installment_details",
            "co_insurance_details",
            "policy_seal_and_sign",
            "warranties_exclusions",
            "suggestedDeductible"
        ] as const;

        parentSections.forEach(sectionKey => {
            const section = qcRemarkOfEachSections?.[sectionKey];

            if (!section) return;

            /* HANDLE SUM INSURED BLOCKS */
            if (sectionKey === 'sum_insured_sections' && typeof section === 'object') {
                Object.values(section as Record<string, any>).forEach(block => {
                    if (!block || typeof block !== 'object') return;

                    if (!block.isActive) return;

                    numberOfModule++;

                    if (String(block.status).toLowerCase() === 'approve' || block.status === 'NA') {
                        numberOfVerifiedModules++;
                    }
                });
                return;
            }

            /* HANDLE NORMAL SECTIONS */
            if (typeof section !== 'object' || !('isActive' in section)) return;

            if (!section.isActive) return;

            numberOfModule++;

            if (String(section.status).toLowerCase() === 'approve' || section.status === 'NA') {
                numberOfVerifiedModules++;
            }
        });

        console.log('numberOfModule', numberOfModule);
        console.log('numberOfVerifiedModules', numberOfVerifiedModules);
        console.log('qcRemarkOfEachSections', qcRemarkOfEachSections);



        setEnableFinalApprove(
            numberOfModule > 0 && numberOfModule === numberOfVerifiedModules
        );
    };



    const handleDrawerToggle = () => {
        setOpenActionDrawer(!openActionDrawer);
    };
    const [detailsView, setDetailsView] = useState<{
        status: boolean;
        data: any;
        policyDetail: any;
    }>({ status: false, data: null, policyDetail: null });
    const handleDetailsClose = () => {
        setDetailsView({ status: false, data: null, policyDetail: null });
    };

    const openPolicyCancelPrompt = (type) => {
        setOpenCancelAlert({ status: true, type });
    };
    const closePolicyCancelPrompt = () => {
        setOpenCancelAlert({ status: false, type: null });
    };

    const hasEmptyRemarksRecursive = (obj: any): boolean => {
        if (Array.isArray(obj)) {
            return obj.some((item) => hasEmptyRemarksRecursive(item));
        } else if (typeof obj === 'object' && obj !== null) {
            return Object.values(obj).some((value) => {
                if (
                    value &&
                    typeof value === 'object' &&
                    'status' in value &&
                    'remarks' in value
                ) {
                    const mod = value as {
                        status: string;
                        remarks?: string;
                        isActive?: boolean;
                    };
                    // ✅ Only consider active items
                    if (
                        mod.isActive &&
                        mod.status === 'endorsement_required' &&
                        !mod.remarks?.trim()
                    ) {
                        console.log('missing module', obj);
                        return true;
                    }
                }
                // Continue recursion
                return hasEmptyRemarksRecursive(value);
            });
        }
        return false;
    };

    const updateQcStatus = (status: string, payload = null) => {
        if (status == 'Endorsement') {
            status = 'Resend';
        }
        if (status === 'Resend') {
            const hasEmptyRemarks = hasEmptyRemarksRecursive(qcRemarkOfEachSections);

            if (hasEmptyRemarks) {
                setShowSnackBarAlert({
                    status: true,
                    type: 'error',
                    message:
                        'Please add remarks for all modules requiring endorsement before submitting.'
                });
                return;
            }
        }

        setLoader(true);
        setOpenCancelAlert({ status: false, type: null });

        const requestPayload = payload
            ? {
                policyId: detailsView?.policyDetail?.insurancePolicy?.id,
                id: detailsView?.policyDetail?.id,
                qcStatus: status,
                qcData: qcRemarkOfEachSections,
                ...payload,
                insuranceCompanyId: detailsView?.policyDetail?.insurancePolicy?.insuranceCompany?.id,
                insuranceCompanyBranchId: detailsView?.policyDetail?.insurancePolicy?.insuranceCompanyBranch?.id,
            }
            : {
                policyId: detailsView?.policyDetail?.insurancePolicy?.id,
                qcStatus: status,
                sendMail: false,
                qcData: qcRemarkOfEachSections,
                id: detailsView?.policyDetail?.id
            };

        console.log('requestPayload', requestPayload)
        

        request({
            url: 'endorsement/qcEndorsementApproval',
            method: 'POST',
            data: requestPayload


        })
            .then((response) => {
                setLoader(false);
                setShowSnackBarAlert({
                    status: true,
                    type: response.status ? 'success' : 'error',
                    message: response['message']
                });

                setTimeout(() => {
                    handleClose();
                }, 400);
            })
            .catch((err: any) => {
                setShowSnackBarAlert({
                    status: true,
                    type: 'error',
                    message: err.message
                });
                setLoader(false);
                handleClose();
            });
    };





    return (
        <>
            {openDialog && <EndorsementCloseRemark
                open={openDialog}
                setOpenDialog={setOpenDialog}
                updateQcStatus={updateQcStatus}
                loader={loader}
            />}

            <Dialog fullScreen open={true} onClose={handleClose}>
                <SnackbarAlert
                    showSnackBarAlert={showSnackBarAlert}
                    handleSnackbarClose={handleSnackbarClose}
                />
                <AppBar sx={{ position: 'relative', height: '70px', background: '#fff' }}>
                    <Toolbar
                        style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}
                    >
                        <IconButton
                            edge="start"
                            onClick={handleClose}
                            aria-label="close"
                            style={{ color: '#000', marginLeft: '20px', marginTop: '15px' }}
                        >
                            <CloseIcon />
                        </IconButton>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <>


                                <LoadingButton onClick={() => setOpenDialog(true)}
                                    sx={{ mt: { xs: 2, md: 0 } }}                                 
                                    variant="contained"
                                    type="button"
                                    style={{ marginRight: 25, marginTop: 15 }}
                                    color="error"
                                >
                                    Close
                                </LoadingButton>


                            </>




                            {enableFinalApprove && (
                                <LoadingButton
                                    sx={{ mt: { xs: 2, md: 0 } }}
                                    loading={loader}
                                    variant="contained"
                                    type="button"
                                    style={{ marginRight: 25, marginTop: 15 }}
                                    onClick={() => updateQcStatus('Approved')}
                                >
                                    Approve
                                </LoadingButton>
                            )}
                            {!enableFinalApprove && (
                                <LoadingButton
                                    sx={{ mt: { xs: 2, md: 0 } }}
                                    loading={loader}
                                    variant="contained"
                                    type="button"
                                    style={{ marginRight: 25, marginTop: 15 }}
                                    color="warning"
                                    onClick={() => openEndorsementPreviewWindow()}
                                >
                                    Resend Endorsement
                                </LoadingButton>
                            )}
                        </div>
                    </Toolbar>
                </AppBar>

                <Grid container>
                    <Grid item xs={6} className={`${classes.compareItemBox}`}>
                        {detailsView?.policyDetail?.endorsementDocument ? (
                            <iframe
                                src={detailsView?.policyDetail?.endorsementDocument}
                                title="syllubus"
                                id="iframe-desktop"
                                style={{ width: '100%', height: '100%' }}
                            ></iframe>
                        ) : (
                            <NoDataAvailable />
                        )}
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        className={`${classes.compareItemBox} ${classes.overFlow}`}
                        style={{ height: '80vh' }}
                    >
                        <PolicyCompareDetailView
                            detailsView={detailsView?.status}
                            handleDetailsClose={handleDetailsClose}
                            placementSlipDetails={detailsView?.data}
                            policyDetail={detailsView?.policyDetail}
                            qcRemarkOfEachSections={qcRemarkOfEachSections}
                            setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                            checkAllModuleIsVerified={checkAllModuleIsVerified}
                        />
                    </Grid>
                </Grid>

                {/* {openCancelAlert && (
          <CancelAlert
            cancelPolicyRequest={updateQcStatus}
            cancelopen={openCancelAlert.status}
            cancelType={openCancelAlert.type}
            closeCancelModal={closePolicyCancelPrompt}
          />
        )} */}
            </Dialog>
            {openEndorsementPreview && <EndorsementPolicyQCPreview
                onClose={() => { setOpenEndorsementPreview(false) }}
                policyData={PolicyCompare}
                createEndorsement={updateQcStatus}
                endorsementloader={loader}
                handleSnackbarClose={handleSnackbarClose}
                showSnackBarAlert={showSnackBarAlert}
            />}
        </>
    );
}

export default PolicyDataCompare;
